import { forgotOrganisationUserPassword } from '@infuse/api/iam/organisation';
import { forgotPassword } from '@infuse/api/iam/user';
import { UserLevel } from '@infuse/iam/user/type';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { useGenericForgotPasswordUser } from './generic/useGenericForgotPasswordUser';
import { forgotTenantUserPassword } from '@infuse/api/iam/tenant';

export const useForgotPasswordUser = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.ORGANISATION) {
    return useGenericForgotPasswordUser({
      apiFn: forgotOrganisationUserPassword,
      forcedParentId: user?.organisationId
    });
  } else if (level === UserLevel.TENANT) {
    return useGenericForgotPasswordUser({
      apiFn: forgotTenantUserPassword,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericForgotPasswordUser({
    apiFn: forgotPassword
  });
};
